export type {
	CallOutcome,
	CategoryShare,
	Dashboard,
	ProspectActivity,
	ProspectDetail,
	ProspectList,
	ProspectProduct,
	ProspectRow,
	ProspectRun,
	ProspectStatus,
} from "@server/prospects";

export type Result = { success: boolean; error?: string };

export const storefrontProductUrl = (slug: string) =>
	`https://www.priceonline.dk/p/${slug}`;
